import React from 'react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-gradient-to-br from-slate-950 via-purple-950 to-black overflow-hidden flex items-center justify-center font-['Inter',_sans-serif]" data-id="element-31">
      {/* Background decorative elements */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-32">
        {/* Radial golden glow behind image area */}
        <div className="absolute top-0 md:top-1/2 left-1/2 md:left-3/4 -translate-x-1/2 md:-translate-y-1/2 w-[400px] h-[400px] md:w-[800px] md:h-[800px] bg-amber-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-33"></div>

        {/* Subtle sparkle dots */}
        <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-amber-300 rounded-full shadow-[0_0_10px_2px_rgba(252,211,77,0.8)] animate-pulse" data-id="element-34"></div>
        <div className="absolute top-3/4 left-1/3 w-1.5 h-1.5 bg-yellow-400 rounded-full shadow-[0_0_12px_3px_rgba(250,204,21,0.8)] animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-35"></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-amber-200 rounded-full shadow-[0_0_8px_2px_rgba(253,230,138,0.8)] animate-pulse" style={{
        animationDelay: '0.5s'
      }} data-id="element-36"></div>
        <div className="absolute bottom-1/4 right-1/3 w-2 h-2 bg-amber-500 rounded-full shadow-[0_0_15px_4px_rgba(245,158,11,0.8)] animate-pulse" style={{
        animationDelay: '1.5s'
      }} data-id="element-37"></div>
        <div className="absolute top-1/2 left-1/6 w-1 h-1 bg-amber-100 rounded-full shadow-[0_0_8px_2px_rgba(254,243,199,0.8)] animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-38"></div>
      </div>

      <div className="container mx-auto px-6 py-16 md:py-24 relative z-10" data-id="element-39">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-12 md:gap-16" data-id="element-40">
          {/* Text Content */}
          <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left space-y-8" data-id="element-41">
            <h1 className="font-['Playfair_Display',_serif] text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-[1.15] tracking-tight" data-id="element-42">
              ¿Puedes{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-400 to-amber-500" data-id="element-43">
                reprogramar tu suerte
              </span>{' '}
              por lo que cuesta un café?{' '}
              <span className="inline-block" data-id="element-44">📉 ➡️ 📈</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 max-w-xl leading-relaxed font-medium" data-id="element-45">
              El Micro-Protocolo Zenith 3-6-9: Solo 7 días para desbloquear tu
              abundancia y eliminar el miedo a la escasez. (Menos de 10 min al
              día).
            </p>

            <div className="w-full flex flex-col items-center md:items-start space-y-5 pt-4" data-id="element-46">
              <a href="https://protocolzenith.com/products/protocolo-zenith-codigo-3-6-9-edicion-7-dias?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-5 rounded-full bg-gradient-to-r from-amber-400 to-amber-600 text-gray-900 text-lg md:text-xl font-bold uppercase tracking-wide hover:scale-105 transition-transform duration-300 cursor-pointer focus:outline-none focus:ring-4 focus:ring-amber-400/50 animate-pulse-glow inline-block text-center no-underline" aria-label="Comprar 7 días de abundancia" data-id="element-47">
                ¡SÍ, QUIERO MIS 7 DÍAS DE ABUNDANCIA ($3.20)! 🚀
              </a>

              <div className="flex items-center justify-center md:justify-start space-x-2 text-sm text-gray-400 font-medium" data-id="element-48">
                <span className="flex items-center" data-id="element-49">
                  <span className="mr-1" data-id="element-50">🔒</span> Pago seguro
                </span>
                <span data-id="element-51">·</span>
                <span data-id="element-52">Sin riesgo</span>
                <span data-id="element-53">·</span>
                <span data-id="element-54">Acceso inmediato</span>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end" data-id="element-55">
            <div className="relative w-[300px] h-[300px] sm:w-[380px] sm:h-[380px] md:w-[450px] md:h-[450px] lg:w-[520px] lg:h-[520px]" data-id="element-56">
              {/* Decorative outer rings */}
              <div className="absolute inset-0 rounded-full border-2 border-amber-500/20 scale-[1.03] animate-[spin_20s_linear_infinite]" data-id="element-57"></div>
              <div className="absolute inset-0 rounded-full border border-amber-300/10 scale-[1.08] animate-[spin_30s_linear_infinite_reverse]" data-id="element-58"></div>

              {/* Image container with float animation */}
              <div className="relative w-full h-full rounded-full p-1.5 bg-gradient-to-br from-amber-300 via-amber-600 to-yellow-900 shadow-[0_0_50px_rgba(245,158,11,0.25)] animate-float" data-id="element-59">
                <img src="https://cdn.magicpatterns.com/uploads/kACGyr1JDQZvg7gRJCizMV/Designer.png" alt="Mujer meditando pacíficamente en luz dorada cálida" className="w-full h-full object-cover rounded-full border-4 border-slate-950" data-id="element-60" />

                {/* Inner glow overlay */}
                <div className="absolute inset-0 rounded-full shadow-[inset_0_0_30px_rgba(0,0,0,0.6)] pointer-events-none" data-id="element-61"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}